// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"spin_wrapper__3dAQ2","icon":"spin_icon__3RVaA","spin":"spin_spin__tHNPD","description":"spin_description__2xhf8","loading":"spin_loading__2HbXV"};